import { fragments } from "..";

import { Params, QueryFn } from ".";

export const incrementWorkspaceNumber = /* GraphQL */ `
  mutation IncrementWorkspaceCounter($input: IncrementWorkspaceCounterInput) {
    incrementWorkspaceCounter(input: $input) {
      id
      sk
      counter
    }
  }
`;

export const getWorkspace: QueryFn = (params?: Params) => /* GraphQL */ `
  query ${params?.label || "GetWorkspace"}($input: ModelGetInput!) {
    getWorkspace(input: $input) {
      ${params?.fields || "id sk"}
    }
  }
`;

export const getWorkspaceUser: QueryFn = (params?: Params) => /* GraphQL */ `
  query ${params?.label || "GetWorkspace"}($input: ModelGetInput!) {
    getWorkspace(input: $input) {
      ${params?.fields || fragments.workspace.listUserWorkspaceFields}
    }
  }
`;

export const updateWorksapceUser = /* GraphQL */ `
  mutation UpdateWorkspaceUser($input: UpdateWorkspaceInput!) {
    updateWorkspace(input: $input) {
      id
      sk
      name
      isDisabled
      createdAt
      updatedAt
    }
  }
`;

export const listBanks = /* GraphQL */ `
  query ListBanks($input: ModelListInput) {
    listBanks(input: $input) {
      items {
        id
        sk
        name
        tags {
          key
          value
        }
      }
      nextToken
    }
  }
`;

export const listContentSharedToWorkspace = /* GraphQL */ `
  query ListContentSharedToWorkspace(
    $authorizationContext: AuthorizationContextInput
  ) {
    listContentSharedToWorkspace(authorizationContext: $authorizationContext) {
      workspace {
        id
        sk
        name
        tags {
          key
          value
        }
      }
      banks {
        id
        sk
        name
        tags {
          key
          value
        }
      }
    }
  }
`;

export const getWorkspaceInvitation = /* GraphQL */ `
  query GetWorkspaceInvitation($input: ModelGetInput) {
    getWorkspaceInvitation(input: $input) {
      id
      sk
      name
      acl
      invitationId
      workspace {
        id
        name
      }
    }
  }
`;
